export default __webpack_public_path__ + "static/duo-wide-2560-17283b496981c8b7061d8b584b4c708a.webp";